import { IconCheck, IconChecks } from '@tabler/icons-react';
import useTheme from 'chat-ui/src/hooks/useTheme';
import { MessageStatusProps } from '../../types';

function MessageStatus({ seen = false, received = false, isSilent }: MessageStatusProps) {
  const { currentTheme } = useTheme();
  const isReceived = received && !seen;
  if (isReceived) return <IconChecks className="self-end ml-1 text-gray-400" size={16} />;
  return seen && !isSilent ? (
    <IconChecks
      style={{ color: currentTheme?.['chat-primary'] }}
      className="self-end ml-1"
      size={16}
    />
  ) : (
    <IconCheck className="self-end ml-1 text-gray-400" size={16} />
  );
}

export default MessageStatus;
